
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h38v38H0z"}}),_c('path',{attrs:{"d":"M22.672 30.643l-.339-.171-.338.171L19 32.16l-2.995-1.516-.338-.171-.34.171-2.994 1.516-2.583-1.307V6.75h18.5v24.102l-2.583 1.307-2.995-1.516zM13 13h6M13 17h6M13 21h6M22 13h3M22 17h3M22 21h3","stroke":"#000","stroke-width":"1.5"}})])
      }
    
      }
    